import { usePrevious } from '@ps/web-shared-components';
import { useEffect } from 'react';

import { usePokerMultiTableTournamentsWidget } from '../model';

const useTableRowsCount = (rowsLength: number) => {
  const { widgetDispatch } = usePokerMultiTableTournamentsWidget();
  const prevRowsLength = usePrevious(rowsLength);

  useEffect(() => {
    if (prevRowsLength !== rowsLength) widgetDispatch.setTableRowsCount(rowsLength);
  }, [prevRowsLength, rowsLength, widgetDispatch]);
};

export default useTableRowsCount;
